const STORAGE_PREFIX = 'content-return:';

export interface ContentReturnState {
  returnTo: string;
  scrollX?: number;
  scrollY?: number;
  selectedRecommendId?: number;
}

export interface ContentReturnNavigationState {
  restoreContentScroll?: boolean;
}

export const saveContentReturnState = (state: ContentReturnState) => {
  sessionStorage.setItem(`${STORAGE_PREFIX}${state.returnTo}`, JSON.stringify(state));
};

export const getContentReturnState = (returnTo: string): ContentReturnState | null => {
  const value = sessionStorage.getItem(`${STORAGE_PREFIX}${returnTo}`);
  if (!value) return null;

  try {
    return JSON.parse(value) as ContentReturnState;
  } catch {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${returnTo}`);
    return null;
  }
};

export const clearContentReturnState = (returnTo: string) => {
  sessionStorage.removeItem(`${STORAGE_PREFIX}${returnTo}`);
};

export const markCurrentHistoryForContentReturn = () => {
  const currentState = window.history.state || {};
  const currentUserState = currentState.usr || {};

  window.history.replaceState({
    ...currentState,
    usr: {
      ...currentUserState,
      restoreContentScroll: true
    }
  }, '');
};
